import jsonwebtoken from 'jsonwebtoken'

export const tokenDecoder = token => token && jsonwebtoken.decode(token)

export const tokenAuthRoles = token => tokenDecoder(token) && tokenDecoder(token).auth

export const tokenCreationDate = token => tokenDecoder(token) && new Date(tokenDecoder(token).iat * 1000)

export const tokenExpirationDate = token => tokenDecoder(token) && new Date(tokenDecoder(token).exp * 1000)

export const tokenExpiresIn = (token) => {
  const currentDate = Date.now()
  const createdDate = tokenCreationDate(token).getTime()
  const expiresDate = tokenExpirationDate(token).getTime()

  const expiresIn = (currentDate > createdDate)
    ? expiresDate - createdDate
    : expiresDate - currentDate

  return expiresIn > 0 ? expiresIn : 0
}

export const tokenIsExpired = token => token && !tokenExpiresIn(token)



// WEBPACK FOOTER //
// ./src/helpers/token.js